var map = {
	"./about-icon.png": 12,
	"./achievement-icon.png": 13,
	"./achievements.pdf": 22,
	"./beauty-dept-reinvention.png": 45,
	"./building-icon.png": 14,
	"./burlington-logo.jpg": 46,
	"./burlington-logo.png": 18,
	"./colors.png": 47,
	"./corporate-hq-expansion.png": 48,
	"./cosmetics-dept-reinvention.png": 49,
	"./design-principles-and-strategy.png": 50,
	"./hamburger-icon.png": 28,
	"./headshot.jpg": 11,
	"./innovation-center.png": 51,
	"./inspiration.png": 52,
	"./jewelry-dept-reinvention.png": 53,
	"./jga-logo.png": 21,
	"./kohls-logo.png": 19,
	"./linkedin-icon.png": 29,
	"./next-gen-store-prototype.png": 54,
	"./omni-channel.png": 55,
	"./pop-up-store-concepts.png": 56,
	"./portfolio-icon.png": 15,
	"./portfolio.pdf": 23,
	"./resume-icon.png": 16,
	"./resume.pdf": 17,
	"./right-sizing-existing-stores.png": 57,
	"./small-footprint-new-store-proto.png": 58,
	"./target-logo.png": 20
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44;